<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M58.3333 87.5C58.3333 71.0833 69.2083 62.4583 84.9583 54C86.6667 53.0833 87.5 51.875 87.5 50.0417C87.5 48.2083 86.6667 46.9583 84.9583 46.0417C69.2917 37.625 58.3333 29 58.3333 12.5H50C50 30.3333 58.125 41.2083 74.7083 45.375V45.8333H12.5V54.1667H74.7083V54.6667C58.0417 58.8333 50 69.4583 50 87.5H58.3333Z" fill="#2B2D33"/>
  </svg>
</template>

<script>
export default {
  name: 'IconArrowRightItalic'
}
</script>
